/* eslint-disable dot-notation */
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';

import {
  getAllCompanies,
  setCurrentCompany,
  selectCompanies,
  selectCurrentCompany,
  selectIsPending,
} from '../../store/companySlice';

const useStyles = makeStyles(() => ({
  select: {
    minWidth: 300,
    marginBottom: 20,
  },
}));

export default function CompanySelectForm() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const companies = useSelector(selectCompanies);
  const currentCompany = useSelector(selectCurrentCompany);
  const isPending = useSelector(selectIsPending);

  const handleChange = (event) => {
    dispatch(setCurrentCompany(companies.find((company) => company.id === event.target.value)));
  };

  useEffect(() => {
    if (!companies || companies.length === 0) {
      dispatch(getAllCompanies());
    }
  }, [dispatch, companies]);

  return (
    <FormControl variant="outlined">
      <InputLabel id="current-company-select-label">Current Company</InputLabel>
      <Select
        className={classes.select}
        value={currentCompany?.id || ''}
        onChange={handleChange}
        disabled={isPending}
        labelId="current-company-select-label"
        label="Current Company"
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {companies.map((company) => (
          <MenuItem key={company.id} value={company.id}>
            {company.clientId}
            {' - '}
            {company.companyName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
